import React, {Component} from 'react'
import TableHead from "./TableHead"
import TableBody from "./TableBody"
import PropTypes from "prop-types"
import {Spin} from "antd"

class ListItemMarkErrorTable extends Component {

    render() {
        const {loading, items, refreshList, selectAll, onCheckALl, arrSelected, onSelected, clearSelected} = this.props

        return (
            <div className="ItemsMarkErrorTable SkuTable">
                <Spin spinning={loading} tip={'Đang lấy dữ liệu...'} size='large'>
                    <table className="table table-striped">
                        <TableHead />
                        <TableBody
                            items={items}
                            loading={loading}
                            refreshList={refreshList}
                            arrSelected={arrSelected}
                            onSelected={onSelected}
                        />
                    </table>
                </Spin>
            </div>
        )
    }
}

ListItemMarkErrorTable.propTypes = {
    refreshList: PropTypes.func.isRequired,
    labels: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    selectAll: PropTypes.bool,
    onCheckALl: PropTypes.func.isRequired,
    arrSelected: PropTypes.array,
    onSelected: PropTypes.func.isRequired,
    clearSelected: PropTypes.func.isRequired
}

export default ListItemMarkErrorTable